import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ServiceRegistrationsState } from './service-registrations.state';
import { ServiceRegistrationService } from "../../service/service-registration.service";
import { IServiceRegistration } from "../../../shared/model/service-registration.model";
import { IOpportunity, OpportunityStatus } from "../../../shared/model/opportunity.model";

export const selectServiceRegistrationsState = createFeatureSelector<ServiceRegistrationsState>('serviceRegistrations');

export const selectAllServiceRegistrations = createSelector(
  selectServiceRegistrationsState,
  (state) => state.registrations
);

export const selectActionItemsForOpportunitiesByStatus = (
  supervisorId: string,
  opportunities: IOpportunity[],
  status: OpportunityStatus
) =>
  createSelector(
    selectServiceRegistrationsState,
    (state: ServiceRegistrationsState): IServiceRegistration[] => {
      const ids: string[] = opportunities
        .filter((opportunity: IOpportunity): boolean => opportunity.status === status)
        .map((opportunity: IOpportunity): string => opportunity.id);

      const filtered: IServiceRegistration[] = state.registrations.filter(
        (registration: IServiceRegistration): boolean =>
          registration.supervisorId === supervisorId && ids.includes(registration.oppId)
      );

      return ServiceRegistrationService.getActionItemsFromRegistrations(filtered);
    }
  );

export const selectServiceRegistrationsByOpportunityId = (opportunityId: string) =>
  createSelector(
    selectAllServiceRegistrations,
    (registrations: IServiceRegistration[]): IServiceRegistration[] => {
      if (!opportunityId) return [];
      return registrations.filter((registration: IServiceRegistration): boolean =>
        registration.oppId === opportunityId);
    }
  );

export const selectActionItemsByOpportunityId = (opportunityId: string) =>
  createSelector(
    selectServiceRegistrationsByOpportunityId(opportunityId),
    (registrations) =>
      ServiceRegistrationService.getActionItemsFromRegistrations(registrations)
  );
